import "./index.css";
import shameGif from "./shame.gif";
import clbIcon from "./clb-icon.png";

export function App() {
  return (
    <div className="container mx-auto p-8 text-center relative z-10 max-w-3xl">
      <div className="bg-card/95 backdrop-blur-sm border-2 border-destructive/20 shadow-2xl rounded-lg">
        <div className="p-12 space-y-8">
          <h1 
            className="text-7xl md:text-8xl font-black text-white mb-4 tracking-tight mx-auto"
            style={{
              backgroundImage: `url(${shameGif})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              aspectRatio: '4/3',
              maxWidth: '600px',
              width: '100%',
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'center',
              paddingBottom: '1rem',
            }}
          >
            Hanba!
          </h1>
          
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground mb-8">
            Zapomněl jsem zamknout počítač
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            Každý, kdo prošel kolem, toho mohl zneužít – ohrozit bezpečnost firmy, zneužít data klientů nebo poškodit naši důvěryhodnost.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-12 pt-8 border-t border-border">
            <div className="flex items-center gap-3">
              <span className="text-2xl">🪟</span>
              <div className="text-left">
                <div className="text-sm text-muted-foreground mb-1">Windows</div>
                <kbd className="px-3 py-2 bg-muted border border-border rounded-md font-mono text-sm font-semibold shadow-sm">
                  Win + L
                </kbd>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <span className="text-2xl">🍎</span>
              <div className="text-left">
                <div className="text-sm text-muted-foreground mb-1">macOS</div>
                <kbd className="px-3 py-2 bg-muted border border-border rounded-md font-mono text-sm font-semibold shadow-sm">
                  Cmd + Ctrl + Q
                </kbd>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <footer className="mt-12 text-center">
        <div className="flex items-center justify-center gap-2 text-muted-foreground text-sm">
          <span>Made with ❤️ at</span>
          <a href="https://cookielab.io" target="_blank" rel="noopener noreferrer" className="inline-block">
            <img src={clbIcon} alt="ICON" className="h-5 w-5 inline-block" />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
